import { Graph } from '../types';

/**
 * Reverse the given graph
 */
function reverseGraph(graph: Graph): Graph {
  const reversed: Graph = {};

  Object.entries(graph).forEach(([parent, children]) => {
    children.forEach((child) => {
      reversed[child] = [...(reversed[child] || []), parent];
    });
  });

  return reversed;
}

export default reverseGraph;
